import React from "react";
import HeroSection from "../components/HeroSection";
import "./ResumePage.css";

export function ResumePage() {
  return (
    <div className="resume-page">
      {/* Shared, full-height hero (no page overrides) */}
      <HeroSection />

      <div className="resume-container">
  {/* SUMMARY */}
  <section className="card">
    <h2>Professional Summary</h2>
    <p>
      Frontend web developer with a background in healthcare operations, medical coding,
      and data tracking. I build responsive React interfaces with clean component structure,
      consistent styling, and accessible UI patterns. I’m also comfortable working with
      Excel/Sheets and foundational SQL for reporting and organization.
    </p>
  </section>

  {/* CORE SKILLS / BADGES */}
  <section className="card">
    <h2>Core Skills</h2>
    <ul className="badge-list">
      <li>React</li>
      <li>JavaScript (ES6+)</li>
      <li>HTML5</li>
      <li>CSS3</li>
      <li>Responsive UI</li>
      <li>Accessibility (a11y)</li>
      <li>React Router</li>
      <li>Git & GitHub</li>
      <li>Netlify Deploy</li>
      <li>Component Design</li>
      <li>Excel / Google Sheets</li>
      <li>SQL (Foundational)</li>
    </ul>
  </section>

  {/* TECH STACK GRID */}
  <section className="card">
    <h2>Tech Stack</h2>
    <div className="skills-grid">
      <div>
        <h4>Languages</h4>
        <p>JavaScript, HTML, CSS, SQL (foundational), Python (intro)</p>
      </div>
      <div>
        <h4>Frameworks/Libraries</h4>
        <p>React, React Router</p>
      </div>
      <div>
        <h4>Build & Tooling</h4>
        <p>Node.js, NPM, Create React App</p>
      </div>
      <div>
        <h4>Deployment</h4>
        <p>Netlify, custom domains, HTTPS, redirects for React Router</p>
      </div>
    </div>
  </section>

  {/* IMPACT HIGHLIGHTS */}
  <section className="card">
    <h2>Impact Highlights</h2>
    <ul className="plain-list bullets">
      <li>
        Contributed to <strong>$1M+ in claim recoveries</strong> through analysis, audits,
        and clear documentation in a regulated healthcare environment.
      </li>
      <li>
        Led and supported a <strong>20-person team</strong> (remote) with case assignment,
        tracking, performance coaching, and confidentiality requirements.
      </li>
      <li>
        Built and deployed React projects to Netlify, including navigation, reusable components,
        and consistent styling across multiple pages.
      </li>
      <li>
        Created spreadsheet-based trackers for tasks, audits, and KPI roll-ups using Excel/Sheets.
      </li>
    </ul>
  </section>

  {/* CERTIFICATIONS */}
  <section className="card">
    <h2>Certifications</h2>
    <ul className="plain-list">
      <li>FAA Part 107 Certified Remote Pilot (sUAS)</li>
      <li>200-Hour Certified Yoga Teacher & SEL Facilitator</li>
    </ul>
  </section>

  {/* EDUCATION */}
  <section className="card">
    <h2>Education & Training</h2>
    <ul className="plain-list">
      <li>
        <strong>Computer Programming Certificate</strong>, Le Moyne College (05/2024)
      </li>
      <li>
        <strong>JavaScript Developer Program (180 hrs)</strong>, MVCC (01/2024)
      </li>
      <li>
        <strong>SQL Series</strong>, MVCC (01/2023)
      </li>
      <li>
        <strong>B.S. Business Administration</strong>, SUNY Empire State College (07/2008)
      </li>
    </ul>
  </section>

  {/* OPTIONAL CTA */}
  <section className="card">
    <h2>Download Resume</h2>
    <p>Prefer a one-page PDF? Download the latest version here:</p>
    <a
      className="btn-primary"
      href="/Christi-Harlow-Resume.pdf"
      target="_blank"
      rel="noreferrer"
    >
      Download Resume (PDF)
    </a>
  </section>
</div>
    </div>
  );
}